import React, { Component } from 'react';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MoreVert from '@material-ui/icons/MoreVert';
import PropTypes from 'prop-types';
import Typography from 'fuse-ui/components/Typography';

import AgGridTableContainer from '../../table/ag-grid-table-container';
import CustomMenu from '../../common/components/custom-menu';
import MenuItem from 'fuse-ui/components/MenuItem';

import { TABLE_TYPES } from '../../table/constants/table-options';
import { withStyles } from '@material-ui/core/styles';
import opacity from '../../common/theme/colors/opacity';

const styles = theme => ( {
    content: {
        height: `calc(100% - ${theme.spacing.unit * 3}px)`,
        padding: `0 ${theme.spacing.unit * 3}px ${theme.spacing.unit}px`,
    },
    icon: {
        '&:focus': {
            color: opacity.black87
        },
        height: 36,
        width: 36,
    },
    noMargin: {
        marginBottom: 0,
    },
    subtitlePadding: {
        padding: ` 0 ${theme.spacing.unit * 3}px ${theme.spacing.unit}px`,
    }
} );

const columnDefs = [
    {
        field: 'name',
        headerName: 'Group Name',
        type: [ 'stringColumn' ],
    },
    {
        field: 'domains',
        headerName: 'Domains',
        suppressSizeToFit: true,
        type: [
            'stringColumn',
            'rightAlignColumn'
        ],
        width: 80,
    },
    {
        field: 'more',
        headerClass: 'ag-hidden',
        headerName: '',
        suppressSizeToFit: true,
        type: [
            'moreIconColumn',
            'rightAlignColumn'
        ],
        width: 68,
    }
];


class DomainGroupingOverview extends Component{
    menuDeleteAction = ( groupId, groupName ) => this.props.deleteGroup( groupId, groupName );

    menuEditAction = ( domainGroupId ) => this.props.editGroup( domainGroupId )

    formatTableData = ( dataSet = [] ) => {
        let returnData = [];

        dataSet.forEach( data => {
            returnData.push(
                {
                    domains: data.domains.length,
                    id: data.id,
                    name: data.name,
                }
            );
            return;
        } );

        return returnData;
    };

    customMenuComponent = ( item ) => (
        <CustomMenu
            MenuTriggerComponent={this.menuTriggerComponent()}
        >
            <MenuItem onClick={() => this.menuEditAction( item.data.id )}>
                Edit
            </MenuItem>
            <MenuItem onClick={() => this.menuDeleteAction( item.data.id, item.data.name )}>
                Delete
            </MenuItem>
        </CustomMenu>
    );

    domainGroupCustomGridOptions =  {
        columnTypes: {
            moreIconColumn: {
                cellRendererFramework: this.customMenuComponent
            },
        },
        defaultColDef: {
            filter: false,
            sortable: true,
            suppressMenu: true,
        },
        rowClass: ['custom-row-height', 'disable-focus'],
        rowHeight: 36,
        sortable: true,
        suppressRowHoverHighlight: true,
    };

    menuTriggerComponent = () => (
        <IconButton className={`${this.props.classes.icon} menu-trigger`} style={{ verticalAlign: 'middle' }}>
            <MoreVert />
        </IconButton>
    );

    render(){
        const { classes, domainGroupingData } = this.props;
        return (
            <>
                <Typography className={classes.subtitlePadding}>{ domainGroupingData.length } Domain Groups</Typography>
                <Divider className={classes.noMargin}/>
                <div className={classes.content}>
                    <AgGridTableContainer
                        columnDefs={columnDefs}
                        rowData={this.formatTableData( domainGroupingData )}
                        customGridOptions={this.domainGroupCustomGridOptions}
                        tableType={TABLE_TYPES.SCROLLING}
                        dataAutomationId="domain-grouping-overview-table"
                    />
                </div>
            </>
        );
    }
};

DomainGroupingOverview.propTypes = {
    classes: PropTypes.object.isRequired,
    deleteGroup: PropTypes.func.isRequired,
    domainGroupingData: PropTypes.array.isRequired,
    editGroup: PropTypes.func.isRequired,
};

export default withStyles( styles )( DomainGroupingOverview );
